/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { access_AccessMeResponse } from '../models/access_AccessMeResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AccessService {
    /**
     * Get the caller's modules
     * Returns the modules the caller holds today. Admin holds every module without a lookup. An employee holds the grants of the professional role on the work contract covering today. When the organization requires a registered device for child data and the request carries no credential of an active device (X-Device-Credential), mobile-employee is not listed; deviceRequired and deviceRegistered tell the app why. The device rule never makes this route answer 403. A parent, an unresolved caller and an employee with no grant get 403.
     * @param xDeviceCredential Device credential from enrolment
     * @returns access_AccessMeResponse OK
     * @throws ApiError
     */
    public static getApiV1AccessMe(
        xDeviceCredential?: string,
    ): CancelablePromise<access_AccessMeResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/v1/access/me',
            headers: {
                'X-Device-Credential': xDeviceCredential,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
    }
}
